module.exports = __webpack_public_path__ + "static/media/Nunito-Light.7383851b.woff2";